import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import TrustedImg from "../../images/location_new/fold11/New-Jersey.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "gatsby";

function Trustedcompany(props) {
  return (
    <div className="trusted_company p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              TekRevol Is Offering Innovation Software Development Services in
              New Jersey
            </h2>
            <p>
              TekRevol is a leading custom software development company in New
              Jersey, providing native and cross-platform solutions. Our
              software developers in NJ create feature-rich software solutions,
              setting unprecedented industry standards. With top-notch coding
              and dedicated client support, we warrant impeccable app
              functionality.
            </p>
            <p>
              Utilizing innovation, we improve your digital journey completely.
              Based in New Jersey, we empower businesses with digital
              transformation and expert professional consultancy. As one of the
              leading software development companies in NJ, we believe in the
              revolutionary powers of technology.
            </p>
            <p>
              Our objective is to reform businesses, advancing their
              competitiveness in New Jersey's vivid landscape. Join us to
              restructure industries, making your business stand out amongst New
              Jersey's exciting digital landscape. Experience digital success
              with TekRevol.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Let's Connect!
            </Link>
          </Col>
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="trustedimg">
              <LazyLoadImage
                src={TrustedImg}
                effect="blur"
                alt="TrustedImg"
                className="img-fluid"
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Trustedcompany;
